// Text styling constants for use in TypeScript
// These correspond to the LESS variables in text-styles.less

export const TEXT_LINE_HEIGHT = 29;

export const fontFamilies = [
	'main-title-hy',
	'main-title-en',
	'main-title-ru',
	'main-text-hy',
	'main-text-en',
	'main-text-ru',
]
